/**
 * DSS Dropdown Filters — Minimal. Dropdown pills + URL navigation for all filters.
 */
(function () {
  'use strict';

  // ── Dropdown open/close ──

  function closeAll() {
    document.querySelectorAll('.dss-dropdown-filter.is-open').forEach(item => {
      item.classList.remove('is-open');
      const t = item.querySelector('.dss-dropdown-filter__trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.dss-dropdown-filter__trigger');
    if (trigger) {
      e.stopPropagation();
      const item = trigger.closest('.dss-dropdown-filter');
      if (!item) return;
      const wasOpen = item.classList.contains('is-open');
      closeAll();
      if (!wasOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');

        // Mobile: position panel below trigger
        if (window.innerWidth <= 749) {
          const panel = item.querySelector('.dss-dropdown-filter__panel');
          if (panel) {
            const rect = trigger.getBoundingClientRect();
            panel.style.top = (rect.bottom + 4) + 'px';
          }
        }
      }
      return;
    }
    if (!e.target.closest('.dss-dropdown-filter')) closeAll();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });

  // ── Pill active state ──

  function syncPillStates() {
    document.querySelectorAll('.dss-dropdown-filter').forEach(item => {
      const trigger = item.querySelector('.dss-dropdown-filter__trigger');
      const panel = item.querySelector('.dss-dropdown-filter__panel');
      if (!trigger || !panel) return;

      const checked = panel.querySelectorAll('input[type="checkbox"]:checked');
      const count = checked.length;
      let badge = trigger.querySelector('.dss-dropdown-filter__active-count');

      if (count > 0) {
        trigger.classList.add('is-active');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'dss-dropdown-filter__active-count';
          trigger.appendChild(badge);
        }
        badge.textContent = count;
      } else {
        trigger.classList.remove('is-active');
        if (badge) badge.remove();
      }

      panel.querySelectorAll('.dss-filter-pill').forEach(pill => {
        const cb = pill.querySelector('input[type="checkbox"]');
        if (cb) pill.classList.toggle('dss-filter-pill--active', cb.checked);
      });
    });
  }

  // ── Navigate on filter change ──

  function buildFilterUrl() {
    const params = new URLSearchParams();

    // Shopify filter checkboxes
    document.querySelectorAll('input[type="checkbox"]:checked').forEach(cb => {
      if (cb.name && cb.name.indexOf('filter.') === 0) {
        params.append(cb.name, cb.value);
      }
    });

    // Price range
    const priceMin = document.querySelector('input[name="filter.v.price.gte"]');
    const priceMax = document.querySelector('input[name="filter.v.price.lte"]');
    if (priceMin && priceMin.value) params.set('filter.v.price.gte', priceMin.value);
    if (priceMax && priceMax.value) params.set('filter.v.price.lte', priceMax.value);

    // Sort
    const sort = document.querySelector('select[name="sort_by"]');
    if (sort && sort.value) params.set('sort_by', sort.value);

    const basePath = window.location.pathname;
    return params.toString() ? `${basePath}?${params.toString()}` : basePath;
  }

  document.addEventListener('change', (e) => {
    if (e.target.type !== 'checkbox' && e.target.tagName !== 'SELECT') return;
    syncPillStates();

    // Only navigate for Shopify filter checkboxes
    if (e.target.type === 'checkbox' && e.target.name && e.target.name.indexOf('filter.') === 0) {
      window.location.href = buildFilterUrl();
      return;
    }
    if (e.target.tagName === 'SELECT') {
      window.location.href = buildFilterUrl();
    }
  });

  // Price range slider
  window.addEventListener('dss-filter-change', () => {
    window.location.href = buildFilterUrl();
  });

  syncPillStates();
})();
